export const TAGADICIONAL_BYID = "TAGADICIONAL_BYID";
export const TAGADICIONAL_CREATE = "TAGADICIONAL_CREATE";
export const TAGADICIONAL_UPDATE = "TAGADICIONAL_UPDATE";
export const TAGADICIONAL_REMOVE = "TAGADICIONAL_REMOVE";
